<template>
  <div class="main__div px-7 py-7">
    <div class="text-right" v-if="is_account">
      <v-btn
        text
        class="text-none font-weight-bold"
        style="border: 1px solid #2d8cff"
        @click="
          toggleBankInfo({
            show: true,
            type: 'view',
            id: is_account.acc_info_id,
          })
        "
      >
        <span style="color: #2d8cff">Account Info</span>
      </v-btn>
    </div>
    <v-row no-gutters>
      <v-col cols="12" md="4" sm="6">
        <tab-component v-model="tabValue" :items="tabList" />
      </v-col>
    </v-row>
    <div class="filter-box">
      <v-row no-gutters>
        <v-col cols="6" sm="3" class="pr-2" v-if="tabValue === 'Groups'">
          <v-select
            v-model="group"
            :items="groupList"
            :item-text="getItemText"
            item-value="id"
            label="Group"
            :menu-props="{ bottom: true, offsetY: true }"
            outlined
            offset-y
            background-color="#fff"
            dense
          >
            <template slot="append-item">
              <div style="text-align: center">
                <v-btn
                  x-small
                  color="#2D8CFF"
                  style="color: white"
                  :loading="loadMoreLoading"
                  v-if="
                    group_page_info.page_number < group_page_info.total_page
                  "
                  @click="loadMore"
                  >Load More</v-btn
                >
              </div>
            </template>
          </v-select>
        </v-col>
        <v-col cols="6" sm="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dates"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedText"
                label="Date Filter"
                outlined
                class="selectBox"
                background-color="#fff"
                multiple
                dense
                ref="inputField"
                readonly
                append-icon="mdi-calendar-range"
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="dates = []"
                @click:append="(menu = !menu), $refs.inputField.focus()"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(dates)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="6"
          sm="3"
          :class="$vuetify.breakpoint.smAndUp ? 'pl-2' : ''"
        >
          <v-select
            v-model="status"
            :items="statusList"
            item-text="name"
            item-value="value"
            label="Status"
            :menu-props="{ bottom: true, offsetY: true }"
            outlined
            offset-y
            background-color="#fff"
            dense
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="3" class="pl-2">
          <v-btn
            text
            class="text-capitalize"
            style="border: 1px solid black"
            @click="clearFilter"
          >
            <v-icon>mdi-filter-remove</v-icon>
            <!-- <span>clear filter</span> -->
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="transaction-table">
      <v-data-table
        :headers="headers"
        :loading="loading"
        loading-text="Please wait ....Loading"
        :items="items"
        :items-per-page="page_info.item_per_page"
        :server-items-length="page_info.item_per_page"
        hide-default-footer
        mobile-breakpoint
      >
        <template v-slot:[`item.payment_id`]="{ item }">
          <div v-if="item.payment_id" class="main-Text">
            {{ item.payment_id }}
          </div>
          <div v-if="item.created" class="sub-Text">
            {{ commonFun.getFormattedDate(item.created) }}
          </div>
        </template>
        <template v-slot:[`item.group_detail`]="{ item }">
          <div
            v-if="item.group_detail.name"
            @click="goToGroup(item.group_detail)"
            class="main-Text"
            style="cursor: pointer"
          >
            {{ item.group_detail.name }}
          </div>
        </template>
        <template v-slot:[`item.video_playlist`]="{ item }">
          <div v-if="item.subscription_type == 'video'" class="py-2">
            <div class="subscription-title">
              {{ item.video ? item.video.title : "" }}
            </div>
            <v-chip small outlined label color="#71B1AA" class="text-uppercase">
              {{ item.subscription_type }}
            </v-chip>
          </div>
          <div v-if="item.subscription_type == 'playlist'" class="py-2">
            <div class="subscription-title">
              {{ item.playlist ? item.playlist.name : "" }}
            </div>
            <v-chip small outlined label color="#D095A0" class="text-uppercase">
              {{ item.subscription_type }}
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.member_detail`]="{ item }">
          <div class="py-4">
            <div
              v-if="item.member_detail"
              @click="goToProfile(item.member_detail)"
              class="member-name-Text"
              style="cursor: pointer"
            >
              {{ item.member_detail.profile.name }}
            </div>
            <div v-if="item.membership" class="sub-Text">
              <div>
                Start Date :
                <span class="span-Text" v-if="item.membership.start_date">{{
                  commonFun.getFormattedDate(item.membership.start_date)
                }}</span>
              </div>
              <div>
                End Date :
                <span class="span-Text" v-if="item.membership.end_date">{{
                  commonFun.getFormattedDate(item.membership.end_date)
                }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:[`item.total_price`]="{ item }">
          <div class="price-text">₹{{ item.total_price }}</div>
        </template>
        <template v-slot:[`item.membership_status`]="{ item }">
          <div
            v-if="item.membership && item.membership.status"
            :class="
              item.membership.status === 'Active'
                ? 'success--text'
                : 'error--text'
            "
            class="status-Text"
          >
            {{ item.membership.status }}
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.payment_status`]="{ item }">
          <div v-if="item.payment_status">
            <v-chip :class="item.payment_status">
              {{ item.payment_status }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
      <v-row class="pt-10">
        <v-col
          cols="12"
          sm="4"
          class="d-flex px-4"
          :class="$vuetify.breakpoint.xsOnly ? 'justify-center' : ''"
        >
          <!-- <div class="alignSelf-center footer-text mt-1 mr-2">
                {{ showing_msg }}
              </div> -->
          <div style="width: 100px" class="alignSelf-center">
            <v-select
              :items="itemsPerPageList"
              v-model="page_info.item_per_page"
              hide-details
              class="pl-3"
              dense
              outlined
              solo
              flat
              color="#2D8CFF"
            ></v-select>
          </div>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
        <v-col
          cols="12"
          sm="4"
          class="d-flex"
          :class="
            $vuetify.breakpoint.xsOnly ? 'justify-center' : 'justify-end pr-3'
          "
        >
          <v-pagination
            v-model="page_info.page_number"
            :length="page_info.total_page"
            :total-visible="5"
            color="#2D8CFF"
            class="pagination"
          >
          </v-pagination>
        </v-col>
      </v-row>
    </div>
    <expert-bank-info-modal></expert-bank-info-modal>
  </div>
</template>
<script>
import Axios from "@/api/BaseAxios.js";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "@/common/commonFunctions";
import { mapActions } from "vuex";
import _ from "lodash";
import accountHeader from "../../common/headers/accounts/index";
import TabComponent from "@/components/VideoCourse/VideoAndPlaylistPage/TabComponent/TabComponent.vue";
export default {
  name: "TransactionDetail",
  components: {
    ExpertBankInfoModal: () =>
      import("@/components/Group/ExpertBankInfoModal/ExpertBankInfoModal"),
    TabComponent,
  },
  data() {
    return {
      menu: false,
      commonFun: commonFunctions,
      dates: [],
      group: null,
      groupList: [],
      loading: false,
      loadMoreLoading: false,
      selectedTab: 0,
      tabValue: "Groups",
      tabList: [
        { name: "Groups", value: "Groups" },
        { name: "Videos", value: "Videos" },
      ],
      page_info: {
        item_per_page: 5,
        page_number: 1,
        total_page: 1,
      },
      itemsPerPageList: [5, 10, 15, 20, 30, 50, 100],
      items: [],
      group_page_info: {
        item_per_page: 10,
        page_number: 1,
        total_page: 1,
      },
      start_date: "",
      end_date: "",
      status: "",
      statusList: [
        { name: "Initiated", value: "initiated" },
        { name: "Successful", value: "successful" },
        { name: "Payout Processed", value: "payout processed" },
        { name: "Payout Settled", value: "payout settled" },
      ],
      is_account: null,
    };
  },
  computed: {
    headers() {
      if (this.tabValue === "Videos") return accountHeader.video;
      else return accountHeader.group;
    },
    dateFormattedText: {
      get() {
        if (this.dates.length) {
          if (this.dates.length == 1) {
            return this.moment(this.dates[0]).format("MMM-DD");
          } else {
            return `${this.moment(this.dates[0]).format(
              "MMM-DD"
            )},${this.moment(this.dates[1]).format("MMM-DD")}`;
          }
        } else {
          return "";
        }
      },
    },
  },
  watch: {
    tabValue() {
      this.items = [];
      this.getTransactionHistory();
    },
    "page_info.page_number": function () {
      this.debounceTransactions();
    },
    "page_info.item_per_page": function () {
      this.getTransactionHistory();
    },
    group: function () {
      this.getTransactionHistory();
    },
    dates: function () {
      if (this.dates.length) {
        if (this.dates.length == 1) {
          this.start_date = this.dates[0];
        } else {
          this.start_date = this.dates[0];
          this.end_date = this.dates[1];
        }
      } else {
        this.start_date = "";
        this.end_date = "";
      }
      this.getTransactionHistory();
    },
    status: function () {
      this.getTransactionHistory();
    },
  },
  methods: {
    ...mapActions({
      toggleBankInfo: "payment/toggleBankInfo",
    }),
    loadMore() {
      if (this.group_page_info.page_number < this.group_page_info.total_page) {
        this.getPremiumGroups();
      }
    },
    getItemText(item) {
      return `${item.name} - ${item.admin.profile.name} (admin)`;
    },
    goToProfile(user) {
      if (commonFunctions.getUserId() == user.id) {
        this.$router.push({
          name: "ProfilePage",
        });
      } else {
        this.$router.push({
          name: "OthersProfilePage",
          params: {
            id: user.id,
            name: user.profile.name,
          },
        });
      }
    },
    goToGroup(group) {
      const { id } = group;
      this.$router.push({
        name: group.group_type == "Premium" ? "premiumGroup" : "GroupDetails",
        params: { id: id },
      });
    },
    getPremiumGroups() {
      this.loadMoreLoading = true;
      const successHandler = (res) => {
        this.groupList = res.data.premium_groups;
        this.group_page_info.total_page = res.data.page_info.total_page;
        this.group_page_info.page_number = res.data.page_info.page_number;
        this.group_page_info.item_per_page = res.data.page_info.detail_count;
        this.loadMoreLoading = false;
      };
      const failureHandler = () => {
        this.loadMoreLoading = false;
      };
      let formData = {};
      formData["detail_count"] = this.group_page_info.item_per_page;
      formData["page_number"] = this.group_page_info.page_number;
      formData["my_group"] = 1;
      Axios.request_GET(
        "/api/premium-groups",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    getTransactionHistory() {
      this.loading = true;
      const successHandler = (res) => {
        if (this.tabValue === "Videos") this.items = res.data.transaction_list;
        else this.items = res.data.transaction_history;
        this.page_info.page_number = res.data.page_info.page_number;
        this.page_info.total_page = res.data.page_info.total_page;
        this.is_account = res.data.is_account;
        this.loading = false;
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["user_id"] = commonFunctions.getUserId();
      formData["page_number"] = this.page_info.page_number;
      formData["detail_count"] = this.page_info.item_per_page;
      if (this.group) {
        formData["group_id"] = this.group;
      }
      if (this.status) {
        formData["status"] = this.status;
      }
      if (this.start_date) {
        formData["start_date"] = this.start_date;
      }
      if (this.end_date) {
        formData["end_date"] = this.end_date;
      }
      if (this.tabValue === "Videos") {
        Axios.request_GET(
          apiUrl.VIDEO_TRANSACTION_HISTORY,
          formData,
          {},
          successHandler,
          failureHandler,
          false
        );
      } else {
        Axios.request_GET(
          apiUrl.TRANSACTION_HISTORY,
          formData,
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },
    clearFilter() {
      this.status = "";
      this.start_date = "";
      this.end_date = "";
      this.group = null;
      this.dates = [];
    },
  },
  mounted() {
    this.getPremiumGroups();
    this.getTransactionHistory();
  },
  created() {
    this.debounceTransactions = _.debounce(function () {
      this.getTransactionHistory();
    }, 500);
  },
};
</script>
<style scoped>
.subscription-title {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #515151;
  padding: 5px 0px;
}
.main__div {
  min-height: 100vh !important;
  width: 100%;
}
.heading-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  color: #333333;
}
.main-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  align-items: center;

  color: #515151;

  /* Inside auto layout */
}
.sub-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  /* identical to box height */

  align-items: center;

  color: #515151;
}
.member-name-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  align-items: center;

  color: #3d3d3d;
}
.span-Text {
  color: #3d3d3d;
}
.price-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  align-items: center;

  color: #3d3d3d;
}
.status-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  align-items: center;
  text-transform: uppercase;
}
span.v-chip.successful {
  background: rgba(47, 128, 237, 0.2);
  border-radius: 60px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  align-items: center;

  color: #2f80ed;
  text-transform: capitalize;
}
span.v-chip.initiated {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  align-items: center;

  /* Orange */

  color: #f2994a;
  background: rgba(242, 153, 74, 0.2);
  border-radius: 60px;
  text-transform: capitalize;
}
span.v-chip.failed {
  background: #f9e9eb;
  color: #eb5757;
  border-radius: 60px;
  text-transform: capitalize;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  align-items: center;
}
</style>
<style>
.tableHeader-text {
  font-family: Avenir !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  /* identical to box height */

  text-transform: uppercase;

  color: #333333 !important;
}
.tableHeader-bg {
  background: #ecf0f4 !important;
}
.tab {
  letter-spacing: 0px !important;
  font-weight: 900 !important;
  font-size: 16px;
  line-height: 22px;
}
.tabs {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: rgba(51, 51, 51, 0.74);
}
.active-tab {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900 !important;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  /* Primary */

  color: #2d8cff;
}
</style>
